import classes from './Articles.module.scss';
import client from '../api/graphql';
import { GET_ARTICLE_CONTENT } from '../api/graphql/queries';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import Markdown from 'markdown-to-jsx';
import PromotionalBanner from '../../components/organisms/promotionalBanner/PromotionalBanner';
import Subfooter from '../../components/organisms/subfooter/Subfooter';
import VideoBlock from '../../components/molecules/video/Video';
import { redirectedPtAndArToEnglish } from '../../utils/functions';

/**
 * Ayoba Web Dynamic Article(s) Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const DynamicArticle = (props) => {
    const router = useRouter();

    const currentSlug = props.slug;
    const { articles, aboutUs, landingPages, whatsNew } = props?.data;
    const { breadcrumb_index, next_article_link_text, go_to_newsroom_link_text } =
        whatsNew.data.attributes.ui_elements[0];

    const currentArticle = articles?.data?.filter((article) => {
        return article?.attributes?.slug === currentSlug;
    });

    useEffect(() => {
        if (!currentArticle.length)
            router
                .push({
                    pathname: `/whats-new`,
                    query: `lang=${router.query?.lang || router.defaultLocale}`
                })
                .then();
    }, [currentArticle]);

    const nextArticle = () => {
        const { data } = articles;
        let next;

        data.map((article, index) => {
            if (article.attributes.slug === currentSlug) {
                if (index + 1 === data.length) {
                    next = data[0].attributes.slug;
                } else {
                    next = data[index + 1].attributes.slug;
                }
            }
        });
        return next;
    };

    /**
     * Prevent render if no content
     */
    if (!currentArticle.length) return null;

    /**
     * Article content
     */
    const { title, image, Video, copy, display_date } = currentArticle[0]?.attributes;
    const { chat_banner } = aboutUs?.data?.attributes;

    return (
        <div className={classes.oNewsArticle}>
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oRow} row`}>
                    <div className={`${classes.oNewsArticle} col`}>
                        <div className={classes.mPageMeta}>
                            <div className={`${classes.mBreadcrumbs} fnt18f`}>
                                <Link
                                    href={{
                                        pathname: `/whats-new`,
                                        query: `lang=${router?.query?.lang || router.defaultLocale}`
                                    }}
                                >
                                    <a className={`${classes.aCrumbLink}`}>{breadcrumb_index}</a>
                                </Link>
                                &nbsp; &gt; {title}
                            </div>
                            <span className={`${classes.aDate} fnt16f`}>{display_date}</span>
                        </div>
                        <h1 className={`${classes.aBlockTitleM} fnt30`}>{title}</h1>
                        {!Video.data && image.data && (
                            <figure className={`${classes.oArticleImage}`}>
                                <span className={classes.mWrapper}>
                                    <Image
                                        src={image.data.attributes?.url}
                                        alt={image.data.attributes?.alternativeText}
                                        height={image.data.attributes?.height}
                                        width={image.data.attributes?.width}
                                        className={classes.aImage}
                                        aria-hidden="true"
                                        layout="responsive"
                                    />
                                </span>
                            </figure>
                        )}
                        {Video.data && <VideoBlock props={Video} />}
                        <div className={classes.mContent}>
                            <h1 className={`${classes.aBlockTitle} fnt30`}>{title}</h1>
                            <div className={`${classes.mArticleBody} fnt16`}>
                                <Markdown>{copy}</Markdown>
                            </div>
                            <Link
                                href={{
                                    pathname: nextArticle(),
                                    query: `lang=${router?.query?.lang || router.defaultLocale}`
                                }}
                            >
                                <a className={`${classes.aTextLink} aTextLink`}>
                                    {next_article_link_text}
                                </a>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className={`row`}>
                    <div className={`${classes.CtaWrapper} col`}>
                        <Link
                            href={{
                                pathname: `/whats-new`,
                                query: `lang=${router?.query?.lang || router.defaultLocale}`
                            }}
                        >
                            <a className={`${classes.aBtnPrimary}`}>
                                <span className={classes.aText}>{go_to_newsroom_link_text}</span>
                            </a>
                        </Link>
                    </div>
                </div>
            </div>
            <div className={classes.oChatBanner}>
                <PromotionalBanner {...chat_banner} />
            </div>
            <Subfooter {...landingPages} />
        </div>
    );
};

export async function getServerSideProps(context) {
    let locale = context.query?.lang || context.defaultLocale;
    locale = redirectedPtAndArToEnglish(locale)

    const { slug } = context.query;

    const { data } = await client.query({
        query: GET_ARTICLE_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data, slug }
    };
}

export default DynamicArticle;
